import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

import { onMounted } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { formatNumber } from "@/services/utils/Strings";
import { convertDateFromUTC } from "@/services/utils/DateParser";
import { useSourcesStore } from "@/store/catalog_data/sources";
import { useOrganizationsBaseDictionaryStore } from "@/store/catalog_data/organization_base";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsItemsTable',
  props: {
    items: {},
    isActiveFirst: { type: Boolean },
    isLoading: { type: Boolean },
    rowsCount: {}
  },
  emits: ["sortTable"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

const sourcesStore = useSourcesStore();
const organizationsStore = useOrganizationsBaseDictionaryStore();

onMounted(async () => {
  if (!sourcesStore.itemList.length) {
    if (sourcesStore.isLoadingInitial && sourcesStore.initialLoadPromise) {
      await sourcesStore.initialLoadPromise;
    } else {
      await sourcesStore.getItems("", [], true, false, 0, 100, true);
    }
  }
  if (organizationsStore.itemList.length === 0) {
    if (!organizationsStore.isLoadingInitial) {
      await organizationsStore.getItems("", [], true, true, 0, 100, true);
    }
  }
});

const getPlatformName = (slug: string): string => {
  const platform = sourcesStore.itemList.find((p) => p.slug === slug);
  return platform ? platform.name : slug;
};

const getOrganizationName = (tenant: string): string => {
  const organization = organizationsStore.itemList.find(
    (o) => o.tenant === tenant
  );
  return organization ? organization.name : tenant;
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    value: _ctx.items,
    class: _normalizeClass([[
      _ctx.items && _ctx.items.length == 0 ? 'empty-table' : '',
      _ctx.isActiveFirst ? 'active-first' : '',
    ], "scroll-table-y main-table scrollbar-custom"]),
    stripedRows: "",
    onSort: sortTable,
    removableSort: "",
    scrollable: "",
    loading: _ctx.isLoading,
    dataKey: "source_segment_id",
    columnResizeMode: "expand"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        field: "number",
        header: "№",
        style: {"min-width":"44px"}
      }, {
        body: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(_ctx.rowsCount + slotProps.index + 1), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "campaign.name",
        header: "Имя кампании",
        style: {"min-width":"150px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.campaign)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: { name: 'campaign', params: { id: slotProps.data.campaign.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(slotProps.data.campaign.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "segment.name",
        header: "Имя сегмента",
        style: {"min-width":"150px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.segment)
            ? (_openBlock(), _createBlock(_component_RouterLink, {
                key: 0,
                to: { name: 'segment', params: { id: slotProps.data.segment.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(slotProps.data.segment.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "segment_rich.rich",
        header: "Охват сегмента",
        style: {"min-width":"120px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.segment_rich && slotProps.data.segment_rich.rich)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(formatNumber)(slotProps.data.segment_rich.rich)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "segment_rich.cost",
        header: "Стоимость сегмента",
        style: {"min-width":"150px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.segment_rich && slotProps.data.segment_rich.cost)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(formatNumber)(slotProps.data.segment_rich.cost / 100)) + " ₽ ", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "ads_cabinet.name",
        header: "Кабинет",
        style: {"min-width":"150px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.ads_cabinet)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(slotProps.data.ads_cabinet.name), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "platform_segment_state.platform_slug",
        header: "Площадка",
        style: {"min-width":"150px"}
      }, {
        body: _withCtx((slotProps) => [
          (
            slotProps.data.platform_segment_state &&
            slotProps.data.platform_segment_state.platform_slug
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(getPlatformName(slotProps.data.platform_segment_state.platform_slug)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "campaign_segment_rich.rich",
        header: "Количество хэшей",
        style: {"min-width":"180px"}
      }, {
        body: _withCtx((slotProps) => [
          (
            slotProps.data.campaign_segment_rich &&
            slotProps.data.campaign_segment_rich.rich
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(formatNumber)(slotProps.data.campaign_segment_rich.rich)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_12, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "campaign_segment_state.display_name",
        header: "Статус сегмента на площадке",
        style: {"min-width":"200px"}
      }, {
        body: _withCtx((slotProps) => [
          (
            slotProps.data.campaign_segment_state &&
            slotProps.data.campaign_segment_state.display_name
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(slotProps.data.campaign_segment_state.display_name), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "source_segment_id",
        header: "ID сегмента на площадке",
        style: {"min-width":"180px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.source_segment_id)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(slotProps.data.source_segment_id), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "ctime",
        header: "Дата загрузки на площадку",
        style: {"min-width":"180px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.ctime)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(convertDateFromUTC)(slotProps.data.ctime)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "segment.tenant",
        header: "Организация",
        style: {"min-width":"150px"}
      }, {
        body: _withCtx((slotProps) => [
          (slotProps.data.segment && slotProps.data.segment.tenant)
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(getOrganizationName(slotProps.data.segment.tenant)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, "-"))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value", "class", "loading"]))
}
}

})